import './Modal.less'
import { ReactNode } from 'react'
import Modal from 'antd/lib/modal'
import CloseOutlined from '@ant-design/icons/lib/icons/CloseOutlined'

export type ModalCompProps = {
    width?: string
    className?: string
    visible: boolean
    centered?: boolean
    modalFooter?: React.ReactElement
    modalHeader?: React.ReactElement
    children: React.ReactElement
    closable?: boolean
    onCancel?: () => void
    disableAnimation?: boolean
    closeIcon?: ReactNode
}

const ModalComp: React.FC<ModalCompProps> = props => {
    return (
        <div>
            <Modal
                data-testid="modal-wrapper"
                width={props.width ?? '670px'}
                className={`modal-comp ${props.className}`}
                title={props.modalHeader}
                closable={props.closable}
                open={props.visible}
                centered={props.centered}
                footer={props.modalFooter ?? null}
                onCancel={props.onCancel}
                transitionName={props.disableAnimation ? '' : undefined}
                closeIcon={props.closeIcon ?? <CloseOutlined />}
            >
                {props.children}
            </Modal>
        </div>
    )
}

export default ModalComp
